import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, MapPin } from 'lucide-react';
const buyers = [{
  name: 'Martina L.',
  city: 'Córdoba'
}, {
  name: 'Julián S.',
  city: 'Rosario'
}, {
  name: 'Florencia M.',
  city: 'CABA'
}, {
  name: 'Diego R.',
  city: 'Mendoza'
}, {
  name: 'Camila G.',
  city: 'La Plata'
}, {
  name: 'Lucas P.',
  city: 'Mar del Plata'
}, {
  name: 'Sofía V.',
  city: 'Tucumán'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showRandomBuyer();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showRandomBuyer = () => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    setCurrentBuyer(randomBuyer);
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup between 15-30 seconds
      const nextDelay = Math.floor(Math.random() * 15000) + 15000;
      setTimeout(showRandomBuyer, nextDelay);
    }, 4000);
  };
  return <AnimatePresence data-id="element-156">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-[calc(100%-2rem)] bg-white rounded-lg shadow-2xl overflow-hidden border border-slate-200" data-id="element-157">
          <div className="bg-[#16a34a] px-3 py-1.5 flex items-center gap-1.5" data-id="element-158">
            <CheckCircle2 className="w-4 h-4 text-white" data-id="element-159" />
            <span className="text-xs font-bold text-white uppercase tracking-wider" data-id="element-160">
              Compra Verificada
            </span>
          </div>
          <div className="p-4 flex items-start gap-3" data-id="element-161">
            <div className="w-10 h-10 rounded-full bg-[#e0f2fe] flex items-center justify-center flex-shrink-0" data-id="element-162">
              <span className="text-[#0369a1] font-bold text-lg" data-id="element-163">
                {currentBuyer.name.charAt(0)}
              </span>
            </div>
            <div data-id="element-164">
              <p className="text-sm text-slate-800" data-id="element-165">
                <span className="font-bold" data-id="element-166">{currentBuyer.name}</span> compró el
                KIT Psicología en Deporte Adaptado
              </p>
              <div className="flex items-center gap-1 mt-1 text-xs text-slate-500" data-id="element-167">
                <MapPin className="w-3 h-3" data-id="element-168" />
                <span data-id="element-169">{currentBuyer.city}, Argentina</span>
                <span className="mx-1" data-id="element-170">•</span>
                <span data-id="element-171">Hace unos minutos</span>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}